/**
 * 建筑专业的二级控制器的控制器类型编号
 */

export enum ARCHI_CTRL_TYPE {
    DRAW_SECTION = 3000, // 绘制截面
    ASSEMBLE_ROOF_SLAP, // 布置屋面板
    ASSIGN_STATION,
    ASSIGN_COLUMN,
    ASSIGN_EAVES_BOARD,
    ASSIGN_GUTTER,
    ADD_BUILDING_COMPONENT,
    ADD_GUTTER_MONITOR_OBJECR, // 添加天沟监测对象
    ADD_ROOF_SLAP_MONITOR_OBJECR, // 添加屋面板监测对象
    ADD_WIND_LOCATION_MONITOR_OBJECR, // 添加风位对象
    DRAW_ROAM_ROUTE, // 绘制漫游路线
}